import { render } from "./DialogView.vue?vue&type=template&id=541d80a7&scoped=true&ts=true"
import script from "./DialogView.vue?vue&type=script&lang=ts"
export * from "./DialogView.vue?vue&type=script&lang=ts"

import "./DialogView.vue?vue&type=style&index=0&id=541d80a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541d80a7"]])

export default __exports__